let text = [];

// Returns current scroll progress (0 to 1)
const getProgress = () => {
    const body = document.body;
    const html = document.documentElement;

    const height = Math.max(
        body.scrollHeight,
        body.offsetHeight,
        html.clientHeight,
        html.scrollHeight,
        html.offsetHeight
    );

    const winScroll = window.pageYOffset || html.scrollTop;
    const scrolled = (winScroll / (height - winScroll)); // Получаем нормализованный прогресс от 0 до 1

    return scrolled || 0;
}

// Update current text based on scroll position
const updateText = (i) => {
    document.querySelector('#word').innerHTML = text[i];
}

window.addEventListener("load", () => {
    // Get all the words in the list
    text = Array.from(document.querySelector('#text').children).map(i => i.innerHTML);

    // Set the initial word
    updateText(0);

    // Update the word when scrolling
    document.addEventListener(
        "scroll",
        () => {
            const progress = getProgress();  // Get the scroll progress from 0 to 1

            console.log('progress', progress);

            // Ensure the index is calculated correctly based on the number of words
            const wordIdx = Math.min(
                Math.floor(progress * (text.length)),  // Умножаем прогресс на количество слов
                text.length - 1 // Ensure the index doesn't go out of bounds
            );

            updateText(wordIdx);
        },
        { passive: true }
    );
});
